<span class="no-wrap">{{ data.final_solution_state === FinalSolutionStateEnum.PENDING ? "Stav ke schválení: " : "" }}{{ data.final_solution_type_name }}</span>
<span *ngIf="data.final_solution_state === FinalSolutionStateEnum.APPROVED || data.final_solution_state === FinalSolutionStateEnum.REJECTED"
      class="tag tag--not-clickable ml-4 occupation-solution-state-indicator"
      [ngClass]="data.final_solution_state === FinalSolutionStateEnum.APPROVED ? 'tag--active' : 'tag--danger'">
</span>
<div *ngIf="data.final_solution_state === FinalSolutionStateEnum.PENDING && approveFinalSolutionTypeService.canApproveFinalSolutionType()" class="mt-5">
  <a class="button" (click)="onApprove()">Schválit</a>
</div>
